import React from "react";
import { ColoredXMLFileIcon } from "../../atom/icons/ColoredXMLFileIcon";
import { ColoredPDFFileIcon } from "../../atom/icons/ColoredPDFFileIcon";
import { ColoredJPGFileIcon } from "../../atom/icons/ColoredJPGFileIcon";
import { BlankFileIcon } from "../../atom/icons/BlankFileIcon";
import { useTranslation } from "react-i18next";

interface DocumentNameProps {
  file_type?: string;
  name: string;
  description?: string;
  optional?: boolean;
}

const knownFileTypes = ["xml", "pdf", "jpg", "jpeg"];

const isKnownFileType = (type: string) => !!knownFileTypes.find((fileType) => fileType === type);

export const DocumentName: React.FC<DocumentNameProps> = ({
  file_type,
  name,
  description,
  optional,
}) => {
  const { t } = useTranslation();

  const ICONS: Record<string, React.ReactElement> = {
    xml: <ColoredXMLFileIcon />,
    pdf: <ColoredPDFFileIcon />,
    jpg: <ColoredJPGFileIcon />,
    jpeg: <ColoredJPGFileIcon />,
  };

  return (
    <div className="flex items-center gap-5">
      <div>{!file_type || !isKnownFileType(file_type) ? <BlankFileIcon /> : ICONS[file_type]}</div>
      <div className="flex flex-col gap-2">
        <p className="font-medium text-[18px] leading-[120%] tracking-[0.2px] text-black line-clamp-2">
          {optional ? t("(Optional)") : null} {name}
        </p>
        <p className="font-light text-[13px] leading-[100%] text-gray-375">{description}</p>
      </div>
    </div>
  );
};
